import React, { Component } from 'react';
import * as helpers from '../../../../../../helpers/helpers';
import { transform } from 'ol/proj.js';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import Projection from 'ol/proj/Projection.js';
import { Vector as VectorLayer } from 'ol/layer';
import { Style } from 'ol/style.js';
import { Vector as VectorSource } from 'ol/source.js';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { unByKey } from 'ol/Observable.js';

class LocationUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputEPSGXValue: null,
      inputEPSGYValue: null,
      inputWebMercatorXValue: null,
      inputWebMercatorYValue: null,
      extentMinX: null,
      extentMinY: null,
      extentMaxX: null,
      extentMaxY: null,
      mapScale: helpers.getMapScale(),
    };

    this.vectorLayer = new VectorLayer({
      source: new VectorSource({
        features: [],
      }),
      style: new Style({
        // image: new Icon({
        //   src: images['problem-marker.svg'],
        // }),
      }),
    });

    this.vectorLayer.setZIndex(500);
    window.map.addLayer(this.vectorLayer);

    this.epsg3908Proj = new Projection({
      code: 'EPSG:3908',
      extent: [6110793.97, 4522984.19, 6925445.34, 5205239.07],
    });
  }

  componentDidMount() {
    helpers.waitForLoad('map', Date.now(), 30, () => {
      window.disableParcelClick = true;

      this.onMapClickEvent = window.map.on('click', this.onMapClick);
      this.onMapMoveEvent = window.map.on('moveend', this.onMapMoveEnd);

      window.map.on('pointermove', (event) => {
        window.map.getTargetElement().style.cursor = 'crosshair';
      });

      proj4.defs([
        [
          'EPSG:3908',
          '+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=6500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs +type=crs',
        ],
      ]);
      register(proj4);

      this.updateExtent();

      window.isCoordinateToolOpen = true;
    });
  }

  updateExtent = () => {
    const extent = window.map.getView().calculateExtent(window.map.getSize());
    this.setState({
      extentMinX: extent[0],
      extentMinY: extent[1],
      extentMaxX: extent[2],
      extentMaxY: extent[3],
      mapScale: helpers.getMapScale(),
    });
  };

  onMapMoveEnd = (evt) => {
    this.updateExtent();
  };

  onMapClick = (evt) => {
    const webMercatorCoords = evt.coordinate;
    const epsg3908Coords = transform(
      webMercatorCoords,
      'EPSG:3857',
      this.epsg3908Proj
    );

    window.map.on('pointermove', (event) => {
      window.map.getTargetElement().style.cursor = '';
    });

    this.createPoint(webMercatorCoords, false);

    this.setState({
      inputEPSGXValue: epsg3908Coords[0],
      inputEPSGYValue: epsg3908Coords[1],
    });

    this.props.updateProblemLocation(epsg3908Coords[0], epsg3908Coords[1]);
  };

  createPoint = (webMercatorCoords, zoom = false) => {
    this.vectorLayer.getSource().clear();
    const pointFeature = new Feature({
      geometry: new Point(webMercatorCoords),
    });
    this.vectorLayer.getSource().addFeature(pointFeature);
  };

  componentWillUnmount() {
    unByKey(this.onPointerMoveEvent);
    unByKey(this.onMapClickEvent);
    unByKey(this.onMapMoveEvent);

    window.disableParcelClick = false;

    window.map.removeLayer(this.vectorLayer);

    window.isCoordinateToolOpen = false;
  }

  onClose() {
    this.props.onClose();
  }

  onZoomClick = (proj, x, y) => {
    x = parseFloat(x);
    y = parseFloat(y);

    if (isNaN(x) || isNaN(y)) return;

    let webMercatorCoords = null;
    if (proj === 'webmercator') {
      webMercatorCoords = [x, y];
    } else if (proj === 'epsg3908') {
      webMercatorCoords = transform([x, y], this.epsg3908Proj, 'EPSG:3857');
    } else return;

    this.createPoint(webMercatorCoords, true);
  };

  render() {
    return <></>;
  }
}

export default LocationUpdate;
